import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

const PackagesVuexModule = {
  namespaced: true,
  state: () => ({
    $_moduleApiPath: "v1.0/Packages",
    $_packages: [],
    $_currentPackage: {},
    $_errorState: {},
    $_actionState: {
      message: "",
      status: 200,
      data: {}
    }
  }),
  getters: {
    allPackages: (state) => state.$_packages,
    currentPackage: (state) => state.$_currentPackage,
    actionState: (state) => state.$_actionState,
    errorState: (state) => state.$_errorState
  },
  actions: {
    initPackage({ commit }) {
      var _package = {
        id: 0,
        name: "",
        isPreviewEnabled: false,
        queueId: null,
        isActive: false,
        packageDocuments: [],
        packageIntegrations: []
      };

      commit("SET_PACKAGE", _package);
    },
    clearPackages({ commit }) {
      commit("SET_PACKAGES", []);
    },
    setPackage({ commit }, _package) {
      commit("SET_PACKAGE", _package);
    },
    async getPackages({ commit, dispatch, state, rootGetters }) {
      var baseUrl = rootGetters.baseUrl;
      var actionLink = baseUrl + state.$_moduleApiPath;
      var axiosConfig = rootGetters.axiosConfig;
      try {
        const response = await axios.get(actionLink, axiosConfig);
        commit("SET_PACKAGES", response.data);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },

    async getPackage({ commit, dispatch, state, rootGetters }, id) {
      var baseUrl = rootGetters.baseUrl;
      var actionLink = baseUrl + state.$_moduleApiPath + "/" + id;
      var axiosConfig = rootGetters.axiosConfig;
      try {
        const response = await axios.get(actionLink, axiosConfig);
        commit("SET_PACKAGE", response.data);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },
    async getAllQueues({ commit, dispatch, rootGetters }) {
      var baseUrl = rootGetters.baseUrl;
      var actionLink = baseUrl + "v1.0/Queues";
      var axiosConfig = rootGetters.axiosConfig;
      try {
        const response = await axios.get(actionLink, axiosConfig);
        return response.data;
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },

    async createPackage({ commit, dispatch, state, rootGetters }, _package) {
      var baseUrl = rootGetters.baseUrl;
      var actionLink = baseUrl + state.$_moduleApiPath;
      var axiosConfig = rootGetters.axiosConfig;
      try {
        _package.id = 0;
        const response = await axios.post(actionLink, _package, axiosConfig);
        _package.id = response.data.id;
        commit("SET_PACKAGE", _package);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },
    async updatePackage({ commit, dispatch, state, rootGetters }, data) {
      var baseUrl = rootGetters.baseUrl;
      var actionLink = baseUrl + state.$_moduleApiPath + "/" + data.id;
      var axiosConfig = rootGetters.axiosConfig;
      try {
        const response = await axios.put(actionLink, data, axiosConfig);
        data.id = response.data.id;

        commit("SET_PACKAGE", data);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },
    async deletePackage({ commit, dispatch, state, rootGetters }, data) {
      var baseUrl = rootGetters.baseUrl;
      var actionLink = baseUrl + state.$_moduleApiPath + "/" + data.id;
      var axiosConfig = rootGetters.axiosConfig;
      var $_axiosConfig = JSON.parse(JSON.stringify(axiosConfig));
      $_axiosConfig.data = data;
      try {
        const response = await axios.delete(actionLink, $_axiosConfig);
        data.id = response.data.id;
        commit("SET_PACKAGE", data);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    }
  },
  mutations: {
    SET_PACKAGES(state, value) {
      state.$_packages = value;
    },
    SET_PACKAGE(state, value) {
      state.$_currentPackage = value;
    },
    SET_ERROR(state, value) {
      state.$_errorState = value;
    }
  }
};

export default PackagesVuexModule;
